import ContactUsForm from "@components/BasicComponents/Forms/ContactUsForm/ContactUsForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Overlay from "@components/CustomTypography/Overlay/Overlay"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import React from "react"

import styles from "./FormSection.module.scss"

type Props = {}

const FormSection = (props: Props) => {
	return (
		<Separator
			id={"book-a-demo"}
			size={128}
			style={{
				color: "white",
				position: "relative",
				background:
					"url(/dreamBroker/footerBGSmall_2024-11-01-085050.jpg)",
				backgroundSize: "cover",
			}}
			type={"padding"}
		>
			<ContainerWrapper>
				<div className={styles.mainWrapper}>
					<div className={styles.contentBox}>
						<Typography
							content={"Ready to get started?"}
							size={Size.XXXL}
							variant={Variant.Title}
							contrast
						/>
						<Separator size={16} />
						<Typography
							content={
								"Contact us now to get a free walk-through of Dream Broker Studio"
							}
							variant={Variant.Paragraph}
							contrast
						/>
					</div>
					<div className={styles.formBox}>
						<Separator customPadding={"25px"}>
							<ContactUsForm
								container={{
									style: {
										color: "black",
									},
								}}
							/>
						</Separator>
					</div>
				</div>
			</ContainerWrapper>
			<Overlay opacity={"0.4"} />
		</Separator>
	)
}

export default FormSection
